module.exports = __webpack_public_path__ + "img/motorsport.92b32a78.svg";